import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { type InfoboxButton, InfoboxComponent } from '@core/components-infobox-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'tellent-assistant-run-error',
  imports: [InfoboxComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-infobox
    type="error"
    iconName="error"
    [isDismissible]="false"
    [buttons]="buttons()"
  >
    <span class="message">{{ 'tlc.tellent_assistant.run_error.generic' | translate }}</span>
  </rt-infobox>`,
  styleUrl: './run-error.component.less',
})
export class TellentAssistantRunErrorComponent {
  private readonly i18n = inject(I18nService);

  protected readonly buttons = computed<InfoboxButton[]>(() =>
    this.retryable()
      ? [
          {
            text: this.i18n.translate('tlc.common.retry'),
            variant: 'outline-error',
            actionFunction: () => this.retry.emit(),
          },
        ]
      : [],
  );

  public readonly retryable = input<boolean>(true);
  public readonly retry = output<void>();
}
